<template>
  <div class="container-help" :class="[packageName]">
    <div class="custom-nav-block" :style="`padding-top:${barHeight}px`">
      <van-nav-bar class="van-bar" title="" left-arrow @click-left="closeWeb" @click-right="toPage('/income/details')">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow02.png" alt="" />
          <span class="tit-left">{{ $t('lang.BaseCommon.k072') }}</span>
        </template>
        <template #right>
          <span class="tit-right">{{ $t('lang.BaseCommon.k074') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main">
      <div class="beans">
        <div class="beans-num">
          <img :src="getMatchImg('beans')" alt="" />
          {{ data.remainIncomeAmount }}
        </div>
        <span>{{ $t('lang.BaseCommon.k102') }}</span>
      </div>
      <div class="income">
        <div class="income-box total-income">
          <div class="num">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.sumIncomeAmount }}
          </div>
          <span>{{ $t('lang.BaseCommon.k081') }}</span>
          <img v-if="packageName === 'kiko'" class="time" @click="toPage('/income/report')" src="./images/report-kiko.png" alt="" />
          <img v-else class="time" @click="toPage('/income/report')" src="@/assets/packageAssets/views/P1_Girls/MyBeans/default/time.png" alt="" />
        </div>
        <span class="line"></span>
        <div class="income-box week-income">
          <div class="num">
            <img :src="getMatchImg('beans')" alt="" />
            {{ data.thisWeekIncomeAmount }}
          </div>
          <span>{{ $t('lang.MyBeans.k016') }}</span>
        </div>
      </div>
      <div class="myincome-list">
        <div
          class="list-item"
          :class="{ todayIncome: key == $t('lang.MyBeans.k020'), lineBottom: key == $t('lang.MyBeans.k020') || key == $t('lang.BaseCommon.k079') }"
          v-for="(key, index) in list.keys()"
          :key="key"
        >
          <span>{{ key }}</span>
          <div class="myincome-beans">
            <i>{{ list.get(key) }}</i>
            <img v-if="index <= 7" :src="getMatchImg('beans')" alt="" />
          </div>
        </div>
      </div>
    </div>
    <div class="withdrawal-box" :style="{ 'margin-bottom': `${bottomBarHeight}px` }">
      <div class="withdrawal" @click="toPage('/withdrawal')">
        {{ $t('lang.BaseCommon.k096') }}
      </div>
    </div>
  </div>
</template>

<script>
import { apiFetchMyBeans } from '@/api/imee.js'
export default {
  components: {},
  props: {},
  data() {
    return {
      data: {},
      list: new Map(),
    }
  },
  created() {
    this.fetchMyBeans()
  },
  mounted() {},
  methods: {
    toPage(path) {
      this.$router.push({
        path,
      })
    },
    fetchMyBeans() {
      apiFetchMyBeans().then((res) => {
        if (res) {
          this.data = res
          this.list.set(this.$t('lang.MyBeans.k020'), res.todayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k080'), res.videoCallTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k077'), res.videoPassTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k063'), res.messageTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k076'), res.giftTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k041'), res.taskTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k073'), res.bonusTodayIncomeAmount)
          this.list.set(this.$t('lang.BaseCommon.k079'), res.otherTodayIncomeAmount)
          this.list.set(this.$t('lang.MyBeans.k011'), this.transformSeconds4(res.onlineDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
          this.list.set(this.$t('lang.MyBeans.k023'), res.timesOfVideoCall)
          this.list.set(this.$t('lang.MyBeans.k022'), this.transformSeconds4(res.videoCallDuration)) // 返回的是多少秒 需要处理成xxm xxm xxs
          this.list.set(this.$t('lang.MyBeans.k002'), res.answeringRate + '%') // 返回的是数字  需要加百分号
          this.list.set(this.$t('lang.MyBeans.k008'), res.replyMessageUsers) //
        }
      })
    },
  },
  watch: {},
  computed: {},
}
</script>
<style lang="scss" scoped>
.container-help {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 80px;
  background: #ffffff;
  background: url('~@/assets/packageAssets/views/P1_Girls/MyBeans/default/bg.png') no-repeat;
  background-size: 100% auto;
  .custom-nav-block {
    background: url('~@/assets/packageAssets/views/P1_Girls/MyBeans/default/bg.png') no-repeat;
    background-size: 100% auto;
  }
  .main {
    margin-top: 20px;
    padding: 0 24px;
    .beans {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      font-family: 'Inter-Regular';
      .beans-num {
        display: flex;
        align-items: center;
        font-size: 24px;
        line-height: 29px;
        color: #ffffff;
        font-weight: 600;
        > img {
          width: 24px;
          margin: 0 2px;
        }
      }
      > span {
        display: block;
        color: rgba($color: #ffffff, $alpha: 0.8);
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .income {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 327px;
      height: 85px;
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      margin: 20px auto 0;
      .income-box {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: 'Inter-Regular';
        font-weight: 400;
        font-size: 12px;
        color: #999999;
        line-height: 15px;
        .num {
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          color: #391d41;
          font-weight: 500;
          font-size: 20px;
          color: #391d41;
          > img {
            width: 18px;
            margin: 0 1px;
          }
        }
      }
      .line {
        display: block;
        width: 1px;
        height: 24px;
        background: #f4f4f4;
        margin: 0 20px;
      }
      .total-income {
        position: relative;
        .time {
          position: absolute;
          right: 0;
          top: -7px;
          width: 16px;
        }
      }
    }
    .myincome-list {
      width: 100%;
      margin-top: 30px;
      .list-item {
        width: 100%;
        // margin-bottom: 20px;
        height: 40px;
        display: flex;
        // align-items: center;
        justify-content: space-between;
        color: #333;
        font-weight: 500;
        font-size: 14px;
        > span {
          display: block;
          white-space: nowrap;
          font-family: 'Inter-Medium';
          line-height: 17px;
        }
        .myincome-beans {
          display: flex;
          i {
            display: block;
            margin: 0 4px;
            color: #666666;
          }
          > img {
            width: 14px;
            height: 14px;
          }
        }
      }
      .todayIncome {
        color: #a337fc;
        font-weight: 600;
        font-family: 'Inter-Bold';
        > span {
          font-family: 'Inter-Bold';
        }
        .myincome-beans {
          i {
            color: #a337fc;
          }
        }
      }
      .lineBottom {
        margin-bottom: 20px;
        border-bottom: 1px solid #f4f4f4;
      }
    }
  }
  .withdrawal-box {
    width: 100%;
    padding: 20px 0 30px 0;
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%);
    background-color: rgba($color: #f4f4f4, $alpha: 0.4);
  }
  .withdrawal {
    width: 289px;
    height: 40px;
    margin: 0 auto;
    background: #a338fc;
    border-radius: 22px;
    font-family: 'Inter-Medium';
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
}

.container-help.kiko {
  position: relative;
  width: 100%;
  min-height: 100vh;
  padding-bottom: 80px;
  background: #ffffff;
  background: url('./images/bg-kiko.png') no-repeat;
  background-size: 100% auto;
  .custom-nav-block {
    background: url('./images/bg-kiko.png') no-repeat;
    background-size: 100% auto;
  }
  .main {
    margin-top: 20px;
    padding: 0 24px;
    .beans {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;
      font-family: 'Inter-Regular';
      .beans-num {
        display: flex;
        align-items: center;
        font-size: 24px;
        line-height: 29px;
        color: #ffffff;
        font-weight: 600;
        > img {
          width: 24px;
          margin: 0 2px;
        }
      }
      > span {
        display: block;
        color: rgba($color: #ffffff, $alpha: 0.8);
        font-size: 14px;
        margin-top: 10px;
      }
    }
    .income {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 327px;
      height: 85px;
      background: #ffffff;
      box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.06);
      border-radius: 10px;
      margin: 20px auto 0;
      .income-box {
        width: 40%;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        font-family: 'Inter-Regular';
        font-size: 12px;
        color: #b2b2b2;
        line-height: 15px;
        .num {
          margin-bottom: 4px;
          display: flex;
          align-items: center;
          color: #333;
          font-weight: 500;
          font-size: 20px;
          > img {
            width: 18px;
            margin: 0 1px;
          }
        }
      }
      .line {
        display: block;
        width: 1px;
        height: 24px;
        background: #f4f4f4;
        margin: 0 20px;
      }
      .total-income {
        position: relative;
        .time {
          position: absolute;
          right: 0;
          top: -7px;
          width: 16px;
        }
      }
    }
    .myincome-list {
      width: 100%;
      margin-top: 30px;
      .list-item {
        width: 100%;
        // margin-bottom: 20px;
        height: 40px;
        display: flex;
        // align-items: center;
        justify-content: space-between;
        color: #333;
        font-weight: 500;
        font-size: 14px;
        > span {
          display: block;
          white-space: nowrap;
          font-family: 'Inter-Medium';
          line-height: 17px;
        }
        .myincome-beans {
          display: flex;
          i {
            display: block;
            margin: 0 4px;
            color: #666666;
          }
          > img {
            width: 14px;
            height: 14px;
          }
        }
      }
      .todayIncome {
        color: #b79b21;
        font-weight: 600;
        font-family: 'Inter-Bold';
        > span {
          font-family: 'Inter-Bold';
        }
        .myincome-beans {
          i {
            color: #b79b21;
          }
        }
      }
      .lineBottom {
        margin-bottom: 20px;
        border-bottom: 1px solid #f4f4f4;
      }
    }
  }
  .withdrawal-box {
    width: 100%;
    padding: 20px 0 30px 0;
    position: fixed;
    bottom: 0px;
    left: 50%;
    transform: translate(-50%);
    background-color: rgba($color: #f4f4f4, $alpha: 0.4);
  }
  .withdrawal {
    width: 289px;
    height: 40px;
    margin: 0 auto;
    background: #ffe242;
    border-radius: 22px;
    font-family: 'Inter-Medium';
    font-weight: 500;
    font-size: 16px;
    color: #ffffff;
    line-height: 40px;
    text-align: center;
  }
}
</style>
<style lang="scss" scoped>
::v-deep .van-nav-bar__left {
  .tit-left {
    color: #fff;
  }
}
::v-deep .van-nav-bar__right {
  .tit-right {
    color: #fff;
  }
}
</style>
